<script>
  import { SkeletonText } from "carbon-components-svelte";
  import { Tooltip } from "paxray-components-svelte";

  export let name = "define name";
  export let value = 42;
  export let unit = "";
  export let showIcon = false;
  export let icon = "check_dark";
  export let loading = false;
  export let colorByValue = false;
  export let sufficientNumberOfRegistrations = 10;
  export let multicolor = null;
  export let tooltipText = "";
  export let tooltipDirection = "bottom";

  $: bgColor = colorByValue
    ? value >= sufficientNumberOfRegistrations
      ? "#8ef095"
      : value === 0
        ? "#f08e90"
        : "#e9f08e"
    : "var(--pax-smoke)";

  $: gradientStyle =
    multicolor && Array.isArray(multicolor)
      ? `linear-gradient(90deg, ${multicolor
          .map(
            (c, i, arr) =>
              `${c.color} ${i === 0 ? 0 : arr.slice(0, i).reduce((a, b) => a + b.percent, 0)}% ${arr
                .slice(0, i + 1)
                .reduce((a, b) => a + b.percent, 0)}%`,
          )
          .join(", ")})`
      : null;
</script>

<div class="kpi_wrapper" style="background: {gradientStyle || bgColor};">
  {#if loading}
    <div class="loading_kpi">
      <SkeletonText />
    </div>
  {:else}
    <div class="left_wrapper">
      {#if showIcon === true}
        <div class="icon">
          <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
        </div>
      {/if}
      <div class="type_wrapper">
        <div class="type" title={name}>{name}</div>
        {#if tooltipText}
          <Tooltip text={tooltipText} direction={tooltipDirection} />
        {/if}
      </div>
    </div>
    <div class="value bold" title={value}>
      {#if $$slots.value}
        <slot name="value" />
      {:else if unit}
        {value} {unit}
      {:else}
        {value}
      {/if}
    </div>
  {/if}
</div>

<style>
  .kpi_wrapper {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
    background-color: var(
      --pax-smoke
    ); /* overridden by inline style when colorByValue is true */
    border-radius: 0.5rem;
    height: 3rem;
    align-items: center;
    gap: 10px;
    width: 100%;
  }

  .left_wrapper {
    display: flex;
    flex: 1 1 auto;
    gap: 1rem;
    text-align: left;
    min-width: 0;
    max-width: 85%;
  }

  .icon {
    width: 1rem;
    display: flex;
    align-items: center;
  }

  .value {
    text-align: -webkit-right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 50%;
    padding: 1px 0;
  }

  .type_wrapper {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    gap: 0.375rem;
    min-width: 0;
  }

  .type {
    display: block;
    flex: 0 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 1px 0;
  }

  .loading_kpi {
    width: 100%;
    padding-top: 0.5rem;
  }
</style>
